import React from 'react'

import { DrawerPageAsync } from '@Components/Drawer/Page'
import { ProductContext } from '@Components/Product/Context'
import { RTEContent } from '@Components/RTEContent'
import { ProductShippingCountdown } from '@Domains/Product/Features/Display/ProductShipping/Countdown'
import { PageType } from '@Generated/graphql'
import { getRTEFieldValue } from '@Globals/CMS/FieldHelpers'
import { MetadataContext } from '@Globals/Metadata'
import { useCheapestShippingPrice, useFreeShippingThreshold } from '@Globals/Metadata/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductShipping.module.scss'

const Text = () => {
  const { t } = useTranslation()
  const { bars } = React.useContext(MetadataContext)
  const product = React.useContext(ProductContext)

  const urgencyBar = React.useMemo(() => {
    const bar = bars?.find(item => item?.type === 'urgency')
    if (!bar) {
      return null
    }

    const overrideProductDescription = getRTEFieldValue(bar?.fields || [], 'overrideProductDescriptionShippingThresholdText')
    if (!overrideProductDescription) {
      return null
    }

    return overrideProductDescription
  }, [bars])

  const cheapestShippingPrice = useCheapestShippingPrice()
  const freeShippingThreshold = useFreeShippingThreshold()

  const price = product?.masterVariant?.price?.discount?.value || (product?.masterVariant?.price?.value || 0)

  const shippingIsFree = price >= (freeShippingThreshold?.value || 0)
    || cheapestShippingPrice === null
    || cheapestShippingPrice?.value === 0

  if (urgencyBar) {
    return <RTEContent className="" data={urgencyBar} elementType="span" />
  }

  if (shippingIsFree) {
    if (cheapestShippingPrice?.value === 0) {
      return t('header:FREE_STANDARD_SHIPPING_ALL_ORDERS')
    }

    return t('products:FREE_SHIPPING_ON_THIS_ITEM')
  }

  if (!cheapestShippingPrice || !freeShippingThreshold) {
    return ''
  }

  return t(
    'products:SHIPPING_X_FREE_OVER_X',
    {
      arg1: cheapestShippingPrice.format,
      arg2: freeShippingThreshold.format,
    },
  )
}

export const ProductShipping = () => (
  <div className={styles.shipping}>
    <ProductShippingCountdown />
    <DrawerPageAsync
      pageID="20"
      pageType={PageType.Modal}
      sourceID="pdp_below_urgency_timer"
      triggerRender={props => (
        <button
          {...props}
          className={styles.shippingOptionsButton}
          type="button"
        >
          <Text />
        </button>
      )}
    />
  </div>
)
